// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"27d21ebd","455":"ddc750cc","977":"1c738e0e"}[chunkId] + ".chunk.js";
};